export default "__VITE_ASSET__txdiX2wY__"